import { render, staticRenderFns } from "./CardInformacoesTipoCliente.vue?vue&type=template&id=3f7718f2&scoped=true&"
import script from "./CardInformacoesTipoCliente.vue?vue&type=script&lang=js&"
export * from "./CardInformacoesTipoCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardInformacoesTipoCliente.vue?vue&type=style&index=0&id=3f7718f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7718f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow,VSkeletonLoader})
